<div class="min-h-screen w-full mx-auto px-4 flex flex-col" *ngIf="config">

  <div class="flex-none mx-auto" id="logo-wrapper">
    <img [src]="getLogoUrl()" alt="Logo" class="logo-image">
  </div>

  <div class="grid grid-cols-1 grid-flow-row gap-4 w-full md:mx-auto py-6" *ngIf="assets">
      <div class="relative w-full">
        <image-slider [images]="filter(assets)" [autoPlaySpeed]="5000"></image-slider>
      </div>
  </div>

  <div class="aspect-square md:w-1/2 md:mx-auto py-32" id="qr-code-wrapper">
    <img [src]="getQRCode()" alt="QR Code" class="border-[2rem] border-white rounded-xl w-full">
  </div>

  <content-block [slug]="'default-disclaimer-bottom'" id="default-disclaimer-bottom-wrapper"></content-block>
</div>

